




































import { Component, Vue, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { Guard } from "@/store/dispatch/types";
import { DispatchRequest, QuickClose, DispatchType } from "@/store/mobile/types";

const Mobile = namespace("mobile");

@Component({})
export default class QuickCloseList extends Vue {
	@Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;
	@Mobile.State((state) => state.QuickCloseList) quickCloseList: QuickClose[];
	@Mobile.Action addNoteForEvent: any;
	@Mobile.Action finishDispatchRequest: any;
	@Mobile.Action continueTour: ({tourId, stepId, dispatchQueueId}) => void;

	// Emit event to core to either hide screen when dispatch finished
	// or re-display details view depending on boolean.
	@Emit("quick-close-finish-dispatch")
	public finishQuickClose(finished: boolean) {
		return finished;
	}

	private get isTourType(): boolean {
        return this.activeDispatchRequest.dispatchType === DispatchType.Tour || this.activeDispatchRequest.dispatchType === DispatchType.Assessment;
    }

	// Method run when outcome selected.
	public async selectOutcome(outcomeTitle: string) {
		let eventId: number = this.activeDispatchRequest.eventID;
		// Add guard note first.
		await this.addNoteForEvent({
			guardNote: `Quick Close: ${outcomeTitle}`,
			eventId: eventId,
		});

		if (this.isTourType) {
			// If the dispatch type is a tour type, just continue with the tour
			await this.continueTour({
				tourId : this.activeDispatchRequest.guardTourId, 
				stepId : this.activeDispatchRequest.objectId,
				dispatchQueueId: this.activeDispatchRequest.dispatchQueueID
			});
		} else {
			// Otherwise, finish the dispatch
			await this.finishDispatchRequest(this.activeDispatchRequest.dispatchQueueID);
		}

		this.finishQuickClose(true);
	}
}
